(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["copy-old-newsletter"] && !Shopify.designMode) return;
  try {
    
    $('#open-signup').on('click', function(e){
      e.preventDefault();
    
      $('#mc_embed_shell').toggleClass('open');
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
  const swiper = new Swiper('.swiper-'+sectionID, {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    autoplay: true,
    slidesPerView: 3,
    spaceBetween: 25,

    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1,
        spaceBetween: 15
      },
      // when window width is >= 768px
      768: {
        slidesPerView: 2,
        spaceBetween: 25
      },
      // when window width is >= 640px
      1199: {
        slidesPerView: 3,
        spaceBetween: 25
      }
    },

    pagination: {
      el: '.swiper-pagination',
      clickable:true,
    },
  
    /* // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  
    // And if we need scrollbar
    scrollbar: {
      el: '.swiper-scrollbar',
    },*/
  });

  } catch(e) { console.error(e); }
})();
})();
